import { Button, Card, Stack, TableCell, TableRow, Typography } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { makeStyles, withStyles } from '@mui/styles';
import Color from 'color'; // v3.2.1

export const StyledTableRow = withStyles(() => ({
  root: {
    height: 40
  }
}))(TableRow);

export const StyledTableCell = withStyles(() => ({
  root: {
    padding: '0px 16px!important'
  }
}))(TableCell);

export const StyledCellText = styled(Typography)(() => ({
  fontSize: '1em',
  root: {
    fontSize: '1em'
  }
}));

export const StyledTableHeaderCell = styled(TableCell)(() => ({
  color: '#374956',
  fontsize: '0.9rem',
  fontWeight: 550
}));
export const useStyles = makeStyles(() => ({
  card: {
    minWidth: '90%',
    minHeight: '120px'
  },

  imageCarouselButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  sliderContainer: {
    width: '100%',
    height: '100%',

    position: 'fixed',
    top: 0,
    left: 0
  },
  tableHeader: {
    color: 'white',
    backgroundColor: 'blue'
  },
  tokenomicsChart: {
    //justifyContent: 'center',
    //display: 'flex',
    height: '100%'
  },
  screenshotImage: {
    objectFit: 'scale-down !important',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  sticky: {
    position: 'sticky',
    left: 0,
    background: 'white'
  },
  gridContainer: {
    paddingLeft: '40px',
    paddingRight: '40px'
  },
  nftContainer: {
    margin: '20px'
  },
  nftDescription: {
    borderColor: 'grey.500',
    borderTop: 1
  },
  detailsContainer: {
    marginTop: 20
  },
  nftMedia: {
    width: 'auto !important',
    height: 'auto',

    borderRadius: '12px'
  }
}));

export const StyledNFTDetailsCard = styled(Card)(({ color, width = 400 }) => ({
  width: width,
  borderRadius: 16,
  boxShadow: '0 6px 12px 0 rgba(34, 35, 58, 0.2)',
  padding: '1rem',
  margin: '0 0 0 0',

  justifyContent: 'center',
  display: 'flex',
  flexDirection: 'column',
  '&:hover': {
    boxShadow: `0 6px 12px 0 ${Color(color).rotate(-12).darken(0.2).fade(0.5)}`
  }
}));

export const StyledRow = styled(Stack)(() => ({
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  flex: 1
}));

export const StyledColumn = styled(Stack)(() => ({
  flexDirection: 'column',
  display: 'flex',
  flex: 1,
  justifyContent: 'center'
}));

export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(purple[500]),
  backgroundColor: purple[500],
  '&:hover': {
    backgroundColor: purple[700]
  }
}));
